/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import axios from "axios";
import "./ReportingDashboard.css";
import config from "../../config";

const ApiBaseUrl = config.NodeApiBaseUrl;
const getDefaultHeaders = () => ({
    "x-tenant-schema": "Amplo111",
    "x-user-id": localStorage.getItem("UserId") || "",
});

class ReportingDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: null,
            parameters: [],
            templates: [],
            operatingUnits: [],
            loading: true,
            error: null,
            hasChanges: false,
        };
    }

    async componentDidMount() {
        try {
            await this.fetchReportingDetails();
            await this.fetchTemplates();
            await this.fetchOperatingUnits();

            // 🔹 Force reapply parameters once templates are loaded
            this.setState((prev) => ({
                parameters: prev.parameters.map((p) => ({
                    ...p,
                    mapped_template_id: p.mapped_template_id
                        ? String(p.mapped_template_id)
                        : "",
                })),
                loading: false,
            }));
        } catch (err) {
            console.error("Error during component mount:", err);
        }
    }


    /** ───────────────────────────────
     *  FETCH REPORT DETAILS
     *  ─────────────────────────────── */
    fetchReportingDetails = async () => {
        try {
            const cardId = this.props.match?.params?.id || 1;
            const apiUrl = `${config.laravelBaseUrl}reporting-dashboard/details/${cardId}`;

            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                },
            });

            if (response.data?.success) {
                const resData = response.data.data;

                let selectedUnits = [];

                // 🔹 Extract selected unit IDs from top-level or details array
                if (resData.operating_unit) {
                    // handle top-level case
                    try {
                        selectedUnits = JSON.parse(resData.operating_unit);
                    } catch {
                        selectedUnits = String(resData.operating_unit)
                            .replace(/\[|\]/g, "")
                            .split(",")
                            .map((id) => parseInt(id.trim()))
                            .filter((id) => !isNaN(id));
                    }
                } else if (Array.isArray(resData.details)) {
                    // handle case inside individual detail items
                    resData.details.forEach((d) => {
                        if (d.operating_unit) {
                            try {
                                const ids = JSON.parse(d.operating_unit);
                                if (Array.isArray(ids)) selectedUnits.push(...ids);
                            } catch {
                                const ids = String(d.operating_unit)
                                    .replace(/\[|\]/g, "")
                                    .split(",")
                                    .map((id) => parseInt(id.trim()))
                                    .filter((id) => !isNaN(id));
                                selectedUnits.push(...ids);
                            }
                        }
                    });
                }

                // Deduplicate IDs
                selectedUnits = [...new Set(selectedUnits)];

                const parameters = Array.isArray(resData.details)
                    ? resData.details.map((d) => ({
                        id: d.id,
                        name: d.data_label,
                        mandatory: d.data_flag === "mandatory",
                        mapped_template_id: d.data_template
                            ? String(d.data_template)
                            : "",
                    }))
                    : [];

                this.setState({
                    details: {
                        id: resData.card_id,
                        card_title: resData.card_title,
                        framework: resData.framework,
                        domain: resData.domain,
                        financial_year: resData.financial_year,
                        selected_units: selectedUnits,
                    },
                    parameters,
                });
            } else {
                this.setState({
                    error: response.data?.message || "No data found.",
                    loading: false,
                });
            }
        } catch (err) {
            console.error("Error fetching reporting details:", err);
            this.setState({
                error: err.message,
                loading: false,
            });
        }
    };

    /** ───────────────────────────────
     *  FETCH OPERATING UNITS
     *  ─────────────────────────────── */
    fetchOperatingUnits = async () => {
        try {
            this.setState({ error: null });

            const companyRes = await axios.get(`${ApiBaseUrl}getAllCompanies`, {
                headers: {
                    ...getDefaultHeaders(),
                    Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                },
            });

            const companies = companyRes.data?.data || [];
            if (!companies.length) {
                this.setState({ error: "No companies found.", loading: false });
                return;
            }

            const selectedUnitIds = this.state.details?.selected_units || [];

            const allUnits = [];
            for (const company of companies) {
                const unitRes = await axios.get(
                    `${ApiBaseUrl}getAllOperatingUnits?companyId=${company.company_id}`,
                    {
                        headers: {
                            ...getDefaultHeaders(),
                            Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                        },
                    }
                );

                const units = unitRes.data?.data || [];
                if (Array.isArray(units) && units.length > 0) {
                    units.forEach((unit) => {
                        allUnits.push({
                            id: unit.unit_id,
                            name: unit.name,
                            location: unit.location,
                            state: unit.state,
                            entity_name: unit.entity_name || "",
                            company_id: unit.company_id,
                            company_name: company.name || "N/A",
                            type_of_operation: unit.type_of_operation || "",
                            selected: selectedUnitIds.includes(parseInt(unit.unit_id)) ||
                                selectedUnitIds.includes(String(unit.unit_id)),
                        });
                    });
                }
            }

            this.setState({
                operatingUnits: allUnits,
            });
        } catch (err) {
            console.error("Error fetching operating units:", err);
            this.setState({
                error: "Failed to fetch operating units.",
                loading: false,
            });
        }
    };

    /** ───────────────────────────────
     *  FETCH TEMPLATE LIST
     *  ─────────────────────────────── */
    fetchTemplates = async () => {
        try {
            const response = await axios.get(`${ApiBaseUrl}getAllTemplates`, {
                headers: {
                    ...getDefaultHeaders(),
                    Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                },
            });

            let templates = [];

            if (Array.isArray(response.data)) {
                templates = response.data;
            } else if (Array.isArray(response.data?.data)) {
                templates = response.data.data;
            }

            if (templates.length > 0) {
                const formattedTemplates = templates.map((t) => ({
                    id: t.template_id,
                    name: t.name,
                    category: t.category,
                    emission_category: t.emission_category,
                    fuel_type: t.fuel_type,
                }));

                this.setState({ templates: formattedTemplates }, () => {
                    // 🔹 Force re-match once templates are in state
                    this.rebindParameterTemplates();
                });
            } else {
                this.setState({ templates: [], error: "No templates found." });
            }
        } catch (err) {
            console.error("Error fetching templates:", err);
            this.setState({ error: "Failed to fetch templates." });
        }
    };



    /** ───────────────────────────────
     *  HANDLE CHANGES
     *  ─────────────────────────────── */
    handleTemplateChange = (id, value) => {
        this.setState((prev) => ({
            parameters: prev.parameters.map((p) =>
                p.id === id ? { ...p, mapped_template_id: value } : p
            ),
            hasChanges: true,
        }));
    };

    handleUnitToggle = (id) => {
        this.setState((prev) => ({
            operatingUnits: prev.operatingUnits.map((u) =>
                u.id === id ? { ...u, selected: !u.selected } : u
            ),
            hasChanges: true,
        }));
    };

    /** ───────────────────────────────
     *  RENDER PARAMETERS TABLE
     *  ─────────────────────────────── */
    renderParametersTable = () => {
        const { parameters, templates } = this.state;
        if (!parameters.length) {
            return (
                <div className="alert alert-light text-center shadow-sm">
                    No reporting parameters found.
                </div>
            );
        }

        return (
            <div className="card mb-4 shadow-sm rounded-lg border-0">
                <div className="card-header bg-white border-0 pb-1">
                    <h6 className="font-weight-bold text-primary mb-1">
                        Parameter Mapping
                    </h6>
                    <p className="text-muted small mb-0">
                        Map each reporting parameter with its corresponding data template.
                    </p>
                </div>

                <div className="card-body p-0">
                    <table className="table table-striped table-sm align-middle mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: "20%" }}>Parameter Name</th>
                                <th style={{ width: "15%", textAlign: "center" }}>Type</th>
                                <th style={{ width: "20%" }}>Mapped Template</th>
                            </tr>
                        </thead>
                        <tbody>
                            {parameters.map((param) => (
                                <tr
                                    key={param.id}
                                    className={
                                        param.mapped_template_id ? "bg-selected-row" : ""
                                    }
                                >
                                    <td className="align-middle pl-3">{param.name}</td>
                                    <td className="text-center align-middle">
                                        <span
                                            className={`badge ${param.mandatory ? "badge-danger" : "badge-secondary"
                                                } px-3 py-1`}
                                        >
                                            {param.mandatory ? "Mandatory" : "Optional"}
                                        </span>
                                    </td>
                                    <td className="align-middle">
                                        <select
                                            className={`form-control form-control-sm rounded ${param.mapped_template_id ? "border-success" : ""
                                                }`}
                                            value={String(param.mapped_template_id || "")}
                                            onChange={(e) => this.handleTemplateChange(param.id, e.target.value)}
                                        >
                                            <option value="">Select Template</option>
                                            {templates.map((t) => (
                                                <option key={t.id} value={String(t.id)}>
                                                    {t.name}
                                                    {t.category ? ` — ${t.category}` : ""}
                                                    {t.emission_category ? ` (${t.emission_category})` : ""}
                                                </option>
                                            ))}
                                        </select>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    /** ───────────────────────────────
     *  RENDER OPERATING UNITS
     *  ─────────────────────────────── */
    renderOperatingUnits = () => {
        const { operatingUnits } = this.state;
        return (
            <div className="card mb-4 shadow-sm rounded-lg border-0">
                <div className="card-header bg-white border-0 pb-1">
                    <h6 className="font-weight-bold text-primary mb-1">
                        Operating Units for Reporting
                    </h6>
                    <p className="text-muted small mb-0">
                        Select which operating units will be included in this report.
                    </p>
                </div>

                <div className="card-body">
                    {operatingUnits && operatingUnits.length > 0 ? (
                        <div
                            className="d-flex flex-wrap justify-content-start"
                            style={{ gap: "12px" }}
                        >
                            {operatingUnits.map((unit) => (
                                <div
                                    key={unit.id}
                                    onClick={() => this.handleUnitToggle(unit.id)}
                                    className={`unit-tile p-3 rounded border text-center ${unit.selected
                                        ? "border-success bg-light text-success"
                                        : "border-muted bg-white text-muted"
                                        }`}
                                    style={{
                                        width: "210px",
                                        transition: "all 0.2s ease-in-out",
                                        cursor: "pointer",
                                    }}
                                >
                                    <i
                                        className={`fas fa-industry mb-2 ${unit.selected ? "text-success" : "text-secondary"
                                            }`}
                                        style={{ fontSize: "1.3rem" }}
                                    ></i>

                                    <p
                                        className="small font-weight-bold mb-1"
                                        style={{ lineHeight: "1.2rem" }}
                                    >
                                        {unit.name}
                                    </p>

                                    {unit.company_name && (
                                        <p className="small text-secondary mb-1">
                                            <strong>{unit.company_name}</strong>
                                        </p>
                                    )}

                                    {unit.entity_name && (
                                        <p className="small text-muted mb-1">
                                            Entity: {unit.entity_name}
                                        </p>
                                    )}

                                    {(unit.location || unit.state) && (
                                        <p className="small text-muted mb-1">
                                            {unit.location}
                                            {unit.location && unit.state ? ", " : ""}
                                            {unit.state}
                                        </p>
                                    )}

                                    <span
                                        className={`badge ${unit.selected ? "badge-success" : "badge-light border"
                                            } px-3`}
                                    >
                                        {unit.selected ? "Included" : "Excluded"}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="alert alert-light text-center shadow-sm mb-0">
                            No operating units available.
                        </div>
                    )}
                </div>
            </div>
        );
    };

    handleSaveReportingDetails = async () => {
        try {
            this.setState({ saving: true, error: null });

            const { details, parameters, operatingUnits } = this.state;

            if (!details?.id) {
                this.setState({
                    error: "Invalid report details. Please reload the page.",
                    saving: false,
                });
                return;
            }

            // 1️⃣ Collect selected template mappings
            const mappedParams = parameters.map((p) => ({
                parameter_id: p.id,
                template_id: p.mapped_template_id || null,
                operating_unit: JSON.stringify(
                    operatingUnits.filter((u) => u.selected).map((u) => u.id)
                ),
            }));

            // 3️⃣ Build payload
            const payload = {
                card_id: details.id,
                parameters: mappedParams,
            };

            // 4️⃣ Send to Laravel backend
            const apiUrl = `${config.laravelBaseUrl}reporting-dashboard/update`;
            const response = await axios.post(apiUrl, payload, {
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                },
            });

            if (response.data?.success) {
                this.setState({ hasChanges: false });
                alert("Reporting configuration saved successfully!");
            } else {
                this.setState({
                    error: response.data?.message || "Failed to save reporting details.",
                });
            }
        } catch (err) {
            console.error("Error saving reporting details:", err);
            this.setState({ error: "Error saving reporting details." });
        } finally {
            this.setState({ saving: false });
        }
    };

    rebindParameterTemplates = () => {
        this.setState((prev) => ({
            parameters: prev.parameters.map((p) => {
                // Keep value as string and re-link if matching template exists
                const matched = prev.templates.find(
                    (t) => String(t.id) === String(p.mapped_template_id)
                );
                return matched ? { ...p, mapped_template_id: String(matched.id) } : p;
            }),
        }));
    };



    /** ───────────────────────────────
     *  MAIN RENDER
     *  ─────────────────────────────── */
    render() {
        const { details, loading, error } = this.state;

        return (
            <>
                <DashboardHeader />
                <div id="wrapper">
                    <DashboardSidebar />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/reporting/dashboard">Reporting</Link>
                                </li>
                                <li className="breadcrumb-item active">Details</li>
                            </ol>

                            <div className="container-fluid container-dashboard">
                                {loading ? (
                                    <div className="text-center mt-5">
                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        ></div>
                                        <p className="mt-2 text-muted">
                                            Loading report details...
                                        </p>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger text-center shadow-sm">
                                        {error}
                                    </div>
                                ) : (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h5 className="heading mb-0 text-dark font-weight-bold">
                                                Reporting Details
                                            </h5>
                                            <Link
                                                style={{
                                                    marginTop: "5px",
                                                    background: "#1232c3",
                                                    color: "white",
                                                }}
                                                to="/reporting/dashboard"
                                                className="btn btn-outline-secondary btn-sm shadow-sm"
                                            >
                                                <i className="fas fa-arrow-left mr-1"></i> Back to
                                                Dashboard
                                            </Link>
                                        </div>

                                        {details && (
                                            <div className="card mb-4 shadow-sm rounded-lg border-0 report-summary-card">
                                                <div className="card-body py-3 px-4">
                                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                                        <div className="mb-3 mb-md-0">
                                                            <h5 className="text-primary font-weight-bold mb-1">
                                                                {details.card_title}
                                                            </h5>
                                                            <p className="text-muted small mb-0">
                                                                Detailed overview and configuration for this
                                                                report.
                                                            </p>
                                                        </div>

                                                        <div className="d-flex flex-wrap justify-content-md-end text-muted small report-info">
                                                            <div className="info-item">
                                                                <span className="label text-uppercase">
                                                                    Framework
                                                                </span>
                                                                <span className="value text-dark">
                                                                    {details.framework}
                                                                </span>
                                                            </div>
                                                            <div className="info-item">
                                                                <span className="label text-uppercase">
                                                                    Domain
                                                                </span>
                                                                <span className="value text-dark">
                                                                    {details.domain}
                                                                </span>
                                                            </div>
                                                            <div className="info-item">
                                                                <span className="label text-uppercase">
                                                                    Financial Year
                                                                </span>
                                                                <span className="value text-dark">
                                                                    {details.financial_year}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {this.renderParametersTable()}
                                        {this.renderOperatingUnits()}
                                        {/* Floating Save Button */}
                                        <div className="floating-save-btn shadow-lg">
                                            <button
                                                className="btn btn-sm btn-save"
                                                onClick={this.handleSaveReportingDetails}
                                                disabled={!this.state.hasChanges || this.state.saving}
                                            >
                                                {this.state.saving ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm mr-2"></span>
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save mr-2"></i> Save Changes
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <FooterComponent />
                    </div>
                </div>
            </>
        );
    }
}

export default ReportingDetails;
